export const REQUEST_OPTIONS = {
	method: "GET",
	headers: {
		"Content-Type": "application/json",
		AuthToken: "System123",
		Platform: "desktop_web",
	},
};
